import {
  Alert,
  DataGrid,
  ErrorOutlineIcon,
  Flex,
  NoRowsOverlay,
  PaperSection,
  Text,
  theme,
} from '@shared/components';

import { useRecurringExamEventCreation } from '../../providers';

import { type RecurringExamEventCreationReviewListItem, columns } from './column';
export default function RecurringExamEventCreationReviewList() {
  const { validateExamEventsData } = useRecurringExamEventCreation();
  const validateExamEventItems: RecurringExamEventCreationReviewListItem[] =
    validateExamEventsData.map((item) => ({
      id: item.requestId,
      examDate: item.examStartedAt,
      registrationStartDate: item.registrationStartedAt,
      registrationEndDate: item.registrationEndedAt,
      createAble: item.isValid,
      reason: item.errorCodes,
    }));

  return (
    <PaperSection title='รายการรอบสอบที่สร้าง'>
      <Flex
        sx={(theme) => ({
          flex: 1,
          p: theme.spacing(6),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(4),
          borderRadius: theme.shape.rounded(2),
        })}
      >
        <Alert severity='info' sx={{ width: '100%', fontWeight: 400 }}>
          <Flex sx={{ gap: (theme) => theme.spacing(3) }}>
            <Text
              component='span'
              sx={{
                textDecoration: 'underline',
                color: theme.palette.info.darker,
              }}
            >
              ระบบจะสร้างเฉพาะรอบสอบที่ผ่านเงื่อนไขเท่านั้น กรุณาตรวจสอบรายการด้านล่างก่อนยืนยัน
            </Text>
          </Flex>
        </Alert>
        <DataGrid
          columns={columns}
          rows={validateExamEventItems}
          columnHeaderHeight={48}
          rowHeight={48}
          disableColumnMenu
          hideFooter
          slots={{
            noRowsOverlay: () => {
              return <NoRowsOverlay title='ไม่พบรอบสอบที่สามารถสร้างได้' icon={ErrorOutlineIcon} />;
            },
          }}
          sx={(theme) => ({
            border: '1px solid',
            borderColor: theme.palette.grey[300],
            '--DataGrid-overlayHeight': '768px',
            borderRadius: theme.shape.rounded(2),
            bgcolor: theme.palette.background.paper,
            '.MuiDataGrid-columnHeaders': {
              bgcolor: theme.palette.grey[100],
              borderColor: theme.palette.grey[300],
            },
            '.MuiDataGrid-columnHeader': {
              p: theme.spacing(3),
            },
            '& .MuiDataGrid-row .MuiDataGrid-cell': {
              alignItems: 'center',
              display: 'flex',
              p: theme.spacing(3),
            },
            '& .MuiDataGrid-cell, & .MuiDataGrid-row': {
              borderBottom: '1px solid',
              borderColor: theme.palette.grey[300],
              '&:last-child': { borderBottom: 'none' },
            },
            '> .MuiDivider-root': {
              mt: '-1px',
              borderColor: theme.palette.grey[300],
            },
          })}
        />
      </Flex>
    </PaperSection>
  );
}
